/**
 * Created by mac on 12/23/20
 */

const Collectible = function (unit) {
    UnitComponent.call(this, unit);
};

Collectible.prototype = Object.create(UnitComponent.prototype);
Collectible.prototype.constructor = Collectible;

Collectible.prototype.onCollection = function (index, callback) {
    if (this.view) {
        this.view.collectionAnimation(index, callback);
    } else {
        callback();
    }
};

Collectible.prototype.needCollectConfirmation = function () {
    const selection = Merge2.current.field.lastSelection;
    return !(selection && this.unit.x === selection.x && this.unit.y === selection.y);
};

Collectible.prototype.handleClick = function () {
    if (this.tryCollect()) {
        cleverapps.effects.fire("ui.button.click");
        return true;
    }
};

Collectible.prototype.tryCollect = function () {
    const data = this.unit.getData();

    if (data.unmergeable) {
        this.collect();
        return true;
    }

    if (this.needCollectConfirmation()) {
        return false;
    }

    this.collect();
    return true;
};

Collectible.prototype.collect = function () {
    if (this.collected) {
        return;
    }

    this.collected = true;

    let rewardType = this.unit.getData().collectible.rewardType || this.unit.code;
    if (rewardType === "coins") {
        rewardType = "soft";
    } else if (rewardType === "rubies") {
        rewardType = "hard";
    }

    const event = cleverapps.EVENTS.EARN.FIELD;
    const reward = new Reward(rewardType, this.getValue(), {
        event,
        onFinish: () => {
            cleverapps.tutorial.trigger("collectibleArrived", { unit: this.unit });
        }
    });
    reward.receiveReward();
    reward.collectRewardsAnimation(this.unit, {
        flyingAnimation: Reward.COLLECT_ANIMATION,
        deltaSource: this.unit.onGetView(),
        path: true
    });

    this.unit.remove(true);

    Merge2.current.setTimeout(() => {
        const data = { affected: this.unit };
        Field.mapEvent(Field.HARVEST, data);
        cleverapps.tutorial.trigger(Field.HARVEST, data);
    }, 0);
};

Collectible.prototype.getValue = function () {
    return this.unit.getData().value;
};
